import { ConnectApi } from '@js/plugins/connectApi';
import { qs } from '@js/utils/toolbox';

if (js_params?.isbeta && qs('#debug-menu-dev-toggle')) {
	// remove data-key="caching" and data-key="environment"
	qs('[data-key="caching"]').remove();
	qs('[data-key="environment"]').remove();

	// Disable vite toggle on beta.flygresor any site with xxx.branch.flygresor.se
	if (location.hostname.includes('beta.flygresor') || location.hostname.includes('.branch.flygresor.se')) {
		qs('[data-key="vite-production"]').remove();
	}

	const errorHandler = error => alert('Error: ' + error.message);

	// DEV
	qs('#debug-menu-dev-toggle').addEventListener('change', async (e) => {
		const isChecked = e.target.checked;
		await ConnectApi('AdminSettings', 'setEnv', [{ DEV: isChecked }]).catch(errorHandler);
		await ConnectApi('MemoryCaching', 'keyFlush', []).catch(errorHandler);
		if (js_params?.controllerClass === 'page\\showresult') {
			location.href = '/';
		} else {
			location.reload();
		}
	});

	// USE_CACHE
	qs('#debug-menu-use-cache-toggle').addEventListener('change', async (e) => {
		const isChecked = e.target.checked;
		await ConnectApi('AdminSettings', 'setEnv', [{ USE_CACHE: isChecked }]).catch(errorHandler);
		await ConnectApi('MemoryCaching', 'keyFlush', []).catch(errorHandler);
		location.reload();
	});

	// DOMAIN_NAME
	qs('#debug-menu-domain-name').addEventListener('change', async (e) => {
		const value = e.target.value;
		await ConnectApi('AdminSettings', 'setEnv', [{ DOMAIN_NAME: value }]).catch(errorHandler);
		await ConnectApi('MemoryCaching', 'keyFlush', []).catch(errorHandler);
		window.location.href = '/';
	});

	// VITE_PRODUCTION
	const productionToggle = qs('#debug-menu-vite-production-toggle');
	if (productionToggle) {
		productionToggle.addEventListener('change', async (e) => {
			const isChecked = e.target.checked;
			await ConnectApi('AdminSettings', 'setEnv', [{ VITE_PRODUCTION: !isChecked }]).catch(errorHandler);
			location.reload();
		});
	}
}
